import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaButtonToggle from './VaButtonToggle.vue'

export default withConfigTransport(VaButtonToggle)
